import { apiRequest } from 'api/apiClient';
import { uploadMedia } from 'utils/mediaResourceUtils';

const createBrand = async ({ name, brand_tracking_id }) => {
  const response = await apiRequest('POST', '/v1/brands', {
    name,
    brand_tracking_id,
  });
  return response;
};

const updateBrand = async ({ uid, name, brand_tracking_id, is_onboarding_process_finished }) => {
  const response = await apiRequest('PATCH', `/v1/brands/${uid}`, {
    name,
    brand_tracking_id,
    is_onboarding_process_finished,
  });
  return response;
};

const updateBrandAndSubdomain = async ({ uid, name, domain }) => {
  const response = await apiRequest('PATCH', `/v1/brands/${uid}`, {
    name,
    domain,
  });
  return response;
};

const updateBrandDefaultLookImage = async ({ uid, imageFile }) => {
  const default_look_image_id = imageFile ? (await uploadMedia([imageFile])).public_id : null;
  const response = await apiRequest('PATCH', `/v1/brands/${uid}`, {
    default_look_image_id,
  });
  return response;
};

const updateTheme = async ({ uid, color, picture_id }) => {
  const response = await apiRequest('PATCH', `/v1/brand-themes/${uid}`, {
    colour: color,
    logo_id: picture_id,
  });
  return response;
};

const updateBrandConfiguration = async ({ uid, configuration }) => {
  const response = await apiRequest('PATCH', `/v1/brand-configs/${uid}`, configuration);
  return response;
};

const BRAND_MUTATIONS = {
  CREATE_BRAND: createBrand,
  UPDATE_BRAND: updateBrand,
  UPDATE_BRAND_AND_SUBDOMAIN: updateBrandAndSubdomain,
  UPDATE_BRAND_DEFAULT_LOOK_IMAGE: updateBrandDefaultLookImage,
  UPDATE_THEME: updateTheme,
  UPDATE_BRAND_CONFIGURATION: updateBrandConfiguration,
};

export default BRAND_MUTATIONS;
